
import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface StatData {
  label: string;
  value: number;
}

interface SchoolSubscriptionsChartProps {
  data: StatData[];
}

export const SchoolSubscriptionsChart = ({ data }: SchoolSubscriptionsChartProps) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Top Schools by Subscriptions</h3>
      <div className="h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" angle={-45} textAnchor="end" height={100} />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#008169" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};
